import { render, staticRenderFns } from "./ValidPrecos.vue?vue&type=template&id=0d09a24c&scoped=true&"
import script from "./ValidPrecos.vue?vue&type=script&lang=js&"
export * from "./ValidPrecos.vue?vue&type=script&lang=js&"
import style0 from "./ValidPrecos.vue?vue&type=style&index=0&id=0d09a24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d09a24c",
  null
  
)

export default component.exports